export const PROJECTS_GET_STATUSES_LIST = 'PROJECTS_GET_STATUSES_LIST';
export const PROJECTS_GET_STATUSES_LIST_SUCCESS = 'PROJECTS_GET_STATUSES_LIST_SUCCESS';
export const PROJECTS_GET_STATUSES_LIST_ERROR = 'PROJECTS_GET_STATUSES_LIST_ERROR';